import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.6.4@antd/es/table/index.js
// module id = 772
// module chunks = 0